// Write-capability source of truth. A mutation is offline-capable only if its
// queue key is declared here AND the mutation registers a replay handler via
// registerMutation. Api modules import these constants for BOTH
// registerMutation(...) and meta.offlineQueueKey — never inline the string.
//
// This module has no side effects, so any screen can check capability without
// importing (and executing) the mutation's module.
export const OFFLINE_WRITE = {
	animalsCreate: "animals:create",
	measurementsCreate: "measurements:create",
	measurementsBatchCreate: "measurements:batch-create",
	operationsCreate: "operations:create",
	paddockMeasurementsCreate: "paddock-measurements:create",
	paddockOperationsCreate: "paddock-operations:create",
	breakdownReportsCreate: "breakdown-reports:create",
	tasksComplete: "tasks:complete",
	manualEntryCreate: "manual-entries:create",
} as const;

export type OfflineWriteKey =
	(typeof OFFLINE_WRITE)[keyof typeof OFFLINE_WRITE];
